<!-- <div class="flip-block-widget" [ngClass]="{'stacked-card': record?.record?.length}">

  <div class="primary-card" fxLayout="column" fxFlex="1 0" fxLayoutAlign="start stretch">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" class="title" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon *ngIf="record?.icon">{{record?.icon}}</mat-icon>
        <div class="sub-text-1" *ngIf="record?.title">{{record?.title}}</div>
      </div>
      <div class="stack-count" fxLayoutAlign="end end" *ngIf="record?.record?.length">
        <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
          <p class="sub-text-1">1 of {{record?.record?.length + 1}}</p>
          <div class="up-arrow" (click)="slide()"></div>
        </div>
      </div>
    </div>
    <div fxLayoutAlign="center center" fxFlex="1 0">
      <ng-content *ngIf="!record?.hide"></ng-content>
      <ng-container *ngFor="let data of record?.record">
        <template [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{$implicit: data}"
          *ngIf="!data?.hide"></template>
      </ng-container>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div>
        <p class="sub-text-2">Due Date <span class="subtext2">OCT 1</span></p>
      </div>
      <div class="stack-count" fxLayoutAlign="end end">
        <div class="sub-txt-patch">
          <p fxLayoutAlign="center center">overdue</p>
        </div>
      </div>
    </div>
  </div>
</div> -->



<div class="flip-block-widget" [ngClass]="{'stacked-card': childLength > 1}">
	<div class="primary-card" fxLayout="column" fxFlex="1 0" fxLayoutAlign="start stretch">
		<div class="stack-count" fxLayoutAlign="end end" *ngIf="childLength > 1">
			<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" (click)="slidenNext()"
				class="cursor-pointer">
				<p class="sub-text-1">
					{{ locale.translate('currentIndex_of_childLength') | handleBar : {'currentIndex': currentIndex, 'childLength': childLength} }}
				</p>
				<div class="up-arrow" [ngClass]="{ 'show' : childLength > 1 }"></div>
			</div>
		</div>
		<div #items fxFlex="1 1">
			<ng-content select="flip-block-item"></ng-content>
		</div>
	</div>
</div>




<!-- <ng-container -->
<!-- <ng-content></ng-content>

<div class="flip-block-widget" [ngClass]="{'stacked-card': record?.record?.length}">

  <div class="primary-card" fxLayout="column" fxFlex="1 0" fxLayoutAlign="start stretch">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" class="title" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon *ngIf="record?.icon">{{record?.icon}}</mat-icon>
        <div class="sub-text-1" *ngIf="record?.title">{{record?.title}}</div>
      </div>
      <div class="stack-count" fxLayoutAlign="end end" *ngIf="record?.record?.length">
        <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
          <p class="sub-text-1">1 of {{record?.record?.length + 1}}</p>
          <div class="up-arrow" (click)="slide()"></div>
        </div>
      </div>
    </div>
    <div fxLayoutAlign="center center" fxFlex="1 0">
      <ng-content *ngIf="!record?.hide"></ng-content>
      <ng-container *ngFor="let data of record?.record">
        <template [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{$implicit: data}"
          *ngIf="!data?.hide"></template>
      </ng-container>
    </div>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div>
        <p class="sub-text-2">Due Date <span class="subtext2">OCT 1</span></p>
      </div>
      <div class="stack-count" fxLayoutAlign="end end">
        <div class="sub-txt-patch">
          <p fxLayoutAlign="center center">overdue</p>
        </div>
      </div>
    </div>
  </div>
</div> -->
